// extracted by mini-css-extract-plugin
module.exports = {"root":"TextWithIcon_root__qSuXo","content":"TextWithIcon_content__kE_Nk","cardTitle":"TextWithIcon_cardTitle__RCG5_","iconWrap":"TextWithIcon_iconWrap__Oy4DR"};